// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__2tCV7","label":"input_label__2rz0h","alert":"input_alert__TdzD4"};